import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-logo">
              <a href="#top" className="logo-link" onClick={scrollToTop}>
                <img src="https://assets.taar.ai/logo.png" alt="Taar AI" className="logo-image" />
                <span className="logo-text">Taar AI</span>
              </a>
            </div>
            <p className="footer-description">
              Building the future of telephony in India with AI-powered solutions and nationwide coverage.
            </p>
          </div>
          
          <div className="footer-links">
            <div className="link-column">
              <h4 className="link-title">Product</h4>
              <ul className="link-list">
                <li><a href="#features">Features</a></li>
                <li><a href="#pricing">Pricing</a></li>
                <li><a href="#integrations">Integrations</a></li>
                <li><a href="#api">API</a></li>
              </ul>
            </div>
            
            <div className="link-column">
              <h4 className="link-title">Solutions</h4>
              <ul className="link-list">
                <li><a href="#enterprise">Enterprise</a></li>
                <li><a href="#startups">Startups</a></li>
                <li><a href="#call-centers">Call Centers</a></li>
                <li><a href="#ai-agents">AI Agents</a></li>
              </ul>
            </div>
            
            <div className="link-column">
              <h4 className="link-title">Company</h4>
              <ul className="link-list">
                <li><a href="#about">About</a></li>
                <li><a href="#careers">Careers</a></li>
                <li><a href="#contact">Contact</a></li>
                <li><a href="#blog">Blog</a></li>
              </ul>
            </div>
            
            <div className="link-column">
              <h4 className="link-title">Resources</h4>
              <ul className="link-list">
                <li><a href="#docs">Documentation</a></li>
                <li><a href="#support">Support</a></li>
                <li><a href="#status">Status</a></li>
                <li><a href="#security">Security</a></li>
              </ul>
            </div>
          </div>
          
          <div className="footer-right">
            <div className="newsletter-section">
              <h4 className="newsletter-title">Stay updated</h4>
              <p className="newsletter-description">
                Get the latest updates on new features and improvements.
              </p>
              <div className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="newsletter-input"
                />
                <button className="newsletter-button">Subscribe</button>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2024 Taar AI. All rights reserved.</p>
            </div>
            
            <div className="footer-legal">
              <a href="#privacy">Privacy Policy</a>
              <a href="#terms">Terms of Service</a>
              <a href="#cookies">Cookie Policy</a>
            </div>
            
            <div className="social-links">
              <a href="#twitter" className="social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" fill="currentColor"/>
                </svg>
              </a>
              <a href="#linkedin" className="social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" fill="currentColor"/>
                  <circle cx="4" cy="4" r="2" fill="currentColor"/>
                </svg>
              </a>
              <a href="#github" className="social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" fill="currentColor"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
